import { Box, CssBaseline, Stack } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { AppLayout, EconsultAppLayout, storageUtils } from '@oh-vcp/components-common';
import { NotificationsViewer, NotifierContextProvider, OHTheme } from '@oh-vcp/components-ui';
import {
  AppNavBarContextProvider,
  EconsultCaseDetailsProvider,
  EconsultFileDownload,
  EconsultFileLinkDownloader,
  EconsultReferralErrorDialog,
  EconsultTopNavigation,
  LegacyCmsRedirect,
  LegacyFileRedirect,
  Login,
  LoginCallback,
  Logout,
  PrivateRoute,
  useAuth,
  useEconsultUserSettingService
} from '@oh-vcp/components-web';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import EconsultCaseView from './cases/econsultCaseView/EconsultCaseView';
import EconsultSettings from './cases/econsultSettings/EconsultSettings';

const App = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const token = storageUtils.getUserToken();
  const { data: userSettings } = useEconsultUserSettingService(token);

  useEffect(() => {
    document.title = t('title.eConsult.home');
  }, [t]);

  const isFileRoute = location.pathname.startsWith('/file');

  return (
    <ThemeProvider theme={OHTheme}>
      <LegacyFileRedirect />
      {/* <LegacyCmsRedirect /> */}
      <CssBaseline />
      {isFileRoute ? (
        <Routes>
          <Route
            path="/file/:id"
            element={
              <PrivateRoute>
                <EconsultFileDownload />
              </PrivateRoute>
            }
          />
        </Routes>
      ) : (
        <EconsultAppLayout about="AppLayout">
          <AppNavBarContextProvider>
            <EconsultCaseDetailsProvider>
              <NotifierContextProvider>
                <NotificationsViewer />
                <EconsultTopNavigation user={user} hideProfileOption userSettings={userSettings} />
                <Stack flexGrow={1} sx={{ flexDirection: { lg: 'column', xs: 'row' } }}>
                  <Routes>
                    <Route path="/error/user" element={<EconsultReferralErrorDialog isOpen />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/login_callback" element={<LoginCallback />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/settings" element={<EconsultSettings />} />
                    <Route
                      path="/"
                      element={
                        <PrivateRoute>
                          <EconsultCaseView />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/case/:providerType/:statusType?/:caseId?"
                      element={
                        <PrivateRoute>
                          <EconsultCaseView />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/file"
                      element={
                        <PrivateRoute>
                          <EconsultFileDownload />
                        </PrivateRoute>
                      }
                    />
                  </Routes>
                </Stack>
              </NotifierContextProvider>
            </EconsultCaseDetailsProvider>
          </AppNavBarContextProvider>
        </EconsultAppLayout>
      )}
    </ThemeProvider>
  );
};

export default App;
